import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import servicesData from "../../data/servicesData";


export default function ServiceDetail() {
  const { serviceSlug } = useParams();
  const service = servicesData.find((s) => s.slug === serviceSlug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [serviceSlug]);

  // ========== 404: Service Not Found ==========
  if (!service) {
    return (
      <section style={{ padding: "150px 0", textAlign: "center" }}>
        <div className="container">
          <h2>Service Not Found</h2>
          <p style={{ color: "#666", marginBottom: "20px" }}>
            The service you're looking for doesn't exist.
          </p>
          <Link to="/services" className="btn btn-primary" style={{ borderRadius: "50px", padding: "12px 30px" }}>
            View All Services
          </Link>
        </div>
      </section>
    );
  }

  // ========== Find Related Services ==========
  const relatedServices = servicesData
    .filter((s) => s.id !== service.id)
    .slice(0, 3);

  return (
    <>
      {/* ========== BREADCRUMBS ========== */}
      <section className="breadcrumbs">
        <div className="container">
          <ol>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li>{service.title}</li>
          </ol>
          <h2>{service.title}</h2>
        </div>
      </section>

      {/* ========== SERVICE DETAIL ========== */}
      <section className="inner-page">
        <div className="container">

          {/* Banner Image */}
          <div className="row mb-5">
            <div className="col-md-12" data-aos="fade-up">
              <img
                src={service.image}
                className="img-fluid"
                alt={service.title}
                style={{ borderRadius: "10px", width: "100%", maxHeight: "400px", objectFit: "cover" }}
              />
            </div>
          </div>

          {/* Short Description */}
          <div className="text-center mb-5" data-aos="fade-up">
            <h3 style={{ color: "#333", maxWidth: "800px", margin: "0 auto", lineHeight: "1.7" }}>
              {service.shortDesc}
            </h3>
          </div>

          {/* Two Column Layout */}
          <div className="row gy-4">

            {/* LEFT: Our Approach */}
            <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
              <h2 style={{ marginBottom: "25px" }}>
                Our {service.title} Approach
              </h2>
              <ul style={{ listStyle: "none", padding: 0 }}>
                {service.approach.map((item, index) => (
                  <li key={index} style={{ marginBottom: "20px", paddingLeft: "15px", borderLeft: "3px solid #007bff" }}>
                    <strong style={{ color: "#333" }}>{item.title}:</strong>
                    <p style={{ color: "#666", margin: "5px 0 0" }}>{item.desc}</p>
                  </li>
                ))}
              </ul>
            </div>

            {/* RIGHT: Why Choose Us */}
            <div className="col-md-6" data-aos="fade-up" data-aos-delay="300">
              <h2 style={{ marginBottom: "25px" }}>
                Why Choose Our {service.title} Services
              </h2>
              <ul style={{ listStyle: "none", padding: 0 }}>
                {service.whyChooseUs.map((item, index) => (
                  <li key={index} style={{ marginBottom: "20px", paddingLeft: "15px", borderLeft: "3px solid #28a745" }}>
                    <strong style={{ color: "#333" }}>{item.title}:</strong>
                    <p style={{ color: "#666", margin: "5px 0 0" }}>{item.desc}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Blockquote */}
          <div className="mt-5" data-aos="fade-up">
            <blockquote style={{
              background: "#f8f9fa",
              padding: "30px",
              borderRadius: "10px",
              borderLeft: "4px solid #007bff",
              fontStyle: "italic",
              color: "#555",
              fontSize: "16px",
              lineHeight: "1.8",
            }}>
              <i className="bi bi-quote" style={{ fontSize: "24px", color: "#007bff", marginRight: "10px" }} />
              Ready to transform your business with our {service.title} services?
              Contact us today for a free consultation and let's build something
              amazing together!
            </blockquote>
          </div>

          {/* CTA Buttons */}
          <div className="text-center mt-4 mb-5" data-aos="fade-up">
            <Link
              to="/get-quote"
              className="btn"
              style={{
                backgroundColor: "#007bff",
                color: "white",
                padding: "14px 40px",
                borderRadius: "50px",
                fontWeight: "600",
                marginRight: "15px",
              }}
            >
              Get a Free Quote <i className="bi bi-arrow-right ms-2" />
            </Link>
            <a
              href="https://wa.me/7000191398"
              target="_blank"
              rel="noreferrer"
              className="btn"
              style={{
                backgroundColor: "#25D366",
                color: "white",
                padding: "14px 40px",
                borderRadius: "50px",
                fontWeight: "600",
              }}
            >
              <i className="bi bi-whatsapp me-2" /> WhatsApp Us
            </a>
          </div>

          {/* ========== RELATED SERVICES ========== */}
          <div className="mt-5">
            <header className="section-header">
              <h2>Other Services</h2>
              <p>Explore more services that can help your business grow</p>
            </header>

            <div className="row gy-4">
              {relatedServices.map((s, index) => (
                <div
                  className="col-lg-4 col-md-6"
                  key={s.id}
                  data-aos="fade-up"
                  data-aos-delay={100 + index * 100}
                >
                  <div className={`service-box ${s.color}`}>
                    <i className={`${s.icon} icon`} />
                    <h3>{s.title}</h3>
                    <p>{s.shortDesc}</p>
                    <Link to={`/services/${s.slug}`} className="read-more">
                      <span>Read More</span>
                      <i className="bi bi-arrow-right" />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>
    </>
  );
}